import { useState } from "react"
import { post } from "../api/api"

export default function Crawler() {
  const [domain, setDomain] = useState("")
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)

  async function start() {
    setLoading(true)
    try {
      const res = await post("/crawl", { domain, limit: 10 })
      setResult(res.data)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page">
      <h1>Website Crawler</h1>
      <div className="card form-row">
        <label>
          Domain
          <input
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="example.com"
          />
        </label>
        <button onClick={start} disabled={loading}>
          {loading ? "Crawling..." : "Start crawl"}
        </button>
      </div>
      {result && <pre>{JSON.stringify(result, null, 2)}</pre>}
    </div>
  )
}
